var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-block-list-icon",class:{
    failed: _vm.isStatusFailed,
    success: _vm.isStatusSuccess,
    neutral: _vm.isStatusNeutral,
  }},[_c('gl-icon',{attrs:{"name":_vm.iconName,"size":_vm.statusIconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }